import React, { useEffect, useState } from 'react';
//For amplitude analytics only
import { AMPLITUDE_API_KEY } from "../app/config";
import * as amplitude from '@amplitude/analytics-browser';
import { sendAnalyticsData } from '../app/log-interface';
import analConfig from '../app/analytics-config';

const useAnalytics = function (props) {
    const [analytics, setAnalytics] = useState({});
    const isEnvLocal = window.location.host.search('localhost') > -1 ? true : false;
    
    useEffect(() => {
        const { events } = analConfig;
        //Restrict analytics for localhost
        if(!isEnvLocal){
            amplitude.init(AMPLITUDE_API_KEY);
        }
        
        analytics.amplitude = amplitude;
        analytics.track = function (eventKey, params, oldState, newState) {
            let eventName = eventKey;
            if(events[eventKey]){
                eventName = events[eventKey];
            }
            // debugger;
            if (eventName) {
                //Insert into amplitude
                //Restrict analytics for localhost
                if(!isEnvLocal){
                    analytics.amplitude.track(eventName, params);

                    //Insert into lodgiq system
                    sendAnalyticsData(eventName, params, oldState, newState);
                }
                
            }
        }
        setAnalytics(analytics);
    }, []);

    return analytics;
};
export { useAnalytics };